// extracted by mini-css-extract-plugin
export var bodySections = "_e4-8";
export var gray = "_e4-7";
export var green = "_e4-4";
export var iconContainer = "_e4-9";
export var iconWidgetContainer = "_e4-1";
export var phoneIcon = "_e4-2";
export var red = "_e4-5";
export var statusDot = "_e4-3";
export var widgetContainer = "_e4-0";
export var yellow = "_e4-6";